import gql from 'graphql-tag';

export const HOME_PAGE_TOPICS_FRAGMENT = gql`
  fragment homePageTopics on HomePageTopicsType {
    topicsTitle
    topicsButtonText
    topicsButtonUrl
    topicsDescription
  }
`;
